import { FC, HTMLAttributes, PropsWithChildren } from "react";
import classes from './surfaceBlock.module.scss'

type TSurfaceBlockVariant = 'default' | 'compact';

interface IProps extends HTMLAttributes<HTMLElement> {
    variant?: TSurfaceBlockVariant;
}

export const SurfaceBlock: FC<PropsWithChildren<IProps>> = ({
    children, className, variant = 'default', ...props
}) => {
    return (
        <section
            {...props}
            className={
                classes.surfaceBlock +
                (variant === 'compact' ? ` ${classes.compact}` : '') +
                (className ? ` ${className}` : '')
            }
        >
            {children}
        </section>
    )
}
